import { Component, OnInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { NzModalRef } from 'ng-zorro-antd';

declare var BMap: any;

@Component({
  selector: 'app-map-position',
  templateUrl: './icc-map-position.component.html',
  styleUrls: ['./icc-map-position.component.less'],
})
export class IccMapPositionComponent implements OnInit {
  constructor(public http: _HttpClient, private modal: NzModalRef) {}

  isLoading: boolean = true;

  // 地图实例
  map: any;

  // 地图上的标注点
  point: any;

  // 地图上的标注
  marker: any;

  // 城市检索功能相关
  local: any;

  // 查询地址
  searchAdress: string = '';

  // 当前经纬度
  currentTude: string = '';
  longitude: number;
  latitude: number;

  ngOnInit() {
    setTimeout(() => {
      this.isLoading = false;
      // 初始化标注点
      this.initPoint();
      // 初始化地图
      this.initMap();
    }, 1000);
  }

  // 初始化标注点
  initPoint() {
    // 传入的当前经纬度坐标
    if (this.currentTude) {
      let _currentTude = this.currentTude.trim();
      let arr = _currentTude.split(',');
      this.longitude = Number(arr[0]);
      this.latitude = Number(arr[1]);
      console.log('arr', arr);
      console.log('this.longitude', this.longitude);
      console.log('this.latitude', this.latitude);
      this.point = new BMap.Point(this.longitude, this.latitude); // 创建点坐标，按照传入的位置
    } else {
      this.point = new BMap.Point(113.33103, 23.11195); // 创建点坐标，默认广州塔的位置
      this.longitude = 113.33103;
      this.latitude = 23.11195;
      this.currentTude = '113.33103 , 23.11195';
    }

    // 自定义标注点
    let myIcon = new BMap.Icon('./assets/images/others/pos_marker.png', new BMap.Size(23, 25), {
      // 指定定位位置:当标注显示在地图上时，其所指向的地理位置距离图标左上角各偏移10像素和25像素。您可以看到在本例中该位置即是图标中央下端的尖角位置。
      anchor: new BMap.Size(10, 25),
      // 设置图片偏移:当您需要从一幅较大的图片中截取某部分作为标注图标时，您需要指定大图的偏移位置，此做法与css sprites技术类似。
      imageOffset: new BMap.Size(0, 0 - 0 * 25), // 设置图片偏移
    });
    this.marker = new BMap.Marker(this.point, { icon: myIcon }); // 创建标注
    // 开启标注的拖拽功能
    this.marker.enableDragging();
    // 监听标注的dragend事件来捕获拖拽后标注的最新位置
    this.marker.addEventListener('dragend', e => {
      this.longitude = this.roundNumber(e.point.lng);
      this.latitude = this.roundNumber(e.point.lat);
      this.currentTude = this.longitude + ', ' + this.latitude;
      console.log('标注拖拽-当前位置：', this.currentTude);
    });
  }

  // 初始化地图
  initMap() {
    this.map = new BMap.Map('map'); //创建地图实例
    this.map.centerAndZoom(this.point, 13); //初始化地图，设置中心点坐标和地图级别
    this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    this.map.addControl(new BMap.NavigationControl()); // 添加控制控件
    this.map.addOverlay(this.marker); // 将标注添加到地图中
    // 绑定地图点击事件
    this.map.addEventListener('click', e => {
      // 改变标注的坐标
      this.marker.setPosition(e.point);
      // 改变经纬度
      this.longitude = this.roundNumber(e.point.lng);
      this.latitude = this.roundNumber(e.point.lat);
      this.currentTude = this.longitude + ' , ' + this.latitude;
      console.log('点击地图-当前位置：', this.currentTude);
    });
    // 开启城市检索 POI功能
    this.local = new BMap.LocalSearch(this.map, { renderOptions: { map: this.map }, pageCapacity: 8 });
  }

  // 城市检索POI功能
  localSearch(adress) {
    this.local.searchInBounds(adress, this.map.getBounds());
  }

  // 四舍五入，精确到小数点后5位
  roundNumber(num) {
    if (!isNaN(num)) {
      let _num = num * 100000;
      return Math.round(_num) / 100000;
    } else {
      return 0;
    }
  }

  // 查询位置按下回车键,查询当前地址经纬度
  pressEnter($event) {
    if ($event.keyCode === 13 && this.searchAdress !== '') {
      console.log('查询位置：', this.searchAdress);
      this.localSearch(this.searchAdress);
    }
  }

  destroy() {
    this.modal.destroy();
  }

  confirm() {
    this.modal.close({
      longitude: this.longitude,
      latitude: this.latitude,
      currentTude: this.currentTude,
    });
  }
}
